import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { UIChart } from 'primeng/chart';
import {DataGraph} from 'src/app/models/data-graph';
import {OptionSelectGraph} from 'src/app/models/optionSelectGraph';

@Component({
  standalone: false,
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss']
})
export class GraphComponent {

  @ViewChild("chart") chart: UIChart;

  @Output() optionSelectGraph = new EventEmitter<OptionSelectGraph>();

  /* Config graph */
  @Input() dataGraph: DataGraph;
  @Input() optionsGraph: any;

  /* header graph */
  @Input() showMenuOption: boolean;
  @Input() titleGraph: string;

  constructor(private el: ElementRef) { }

  selectOptionMenu(id: string){

    this.clearOptionSelected();

    let buttonSelected = this.el.nativeElement.querySelector(`#${id}`);
    buttonSelected.classList.add('selected');

    this.optionSelectGraph.emit({period: buttonSelected.value});
  }

  private clearOptionSelected(){
    this.el.nativeElement.querySelectorAll(".btn-menu").forEach(
      (      element: { classList: { remove: (arg0: string) => void }; }) => {
        element.classList.remove('selected');
    });
  }

  refreshGraph(){
    this.chart.reinit();
  }
}
